import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Loading from "../../components/loading/loading";
import "../../global.css";
import { userRequest } from "../../requestMethods";
import { formatTimeDDMMYYY } from "../../util/helper";
import Switch from "@mui/material/Switch";
import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import CustomGrid from "../../components/grid/CustomGrid";

export default function CompanyList() {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getCompanies();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function returnUrl(configUI) {
    if (configUI && configUI.isRetail && configUI.isRetail === "both") {
      return "Varejo/Atacado";
    }
    if (configUI && configUI.isRetail && configUI.isRetail === "true") {
      return "Varejo";
    }
    return "Atacado";
  }

  const getCompanies = async () => {
    try {
      setIsLoading(true);
      const res = await userRequest.get(`company`);
      setData(
        res.data.map((item) => ({
          companyId: item.companyId,
          name: item.name,
          layout: typeLayout(JSON.parse(item.configUI)),
          configUI: JSON.parse(item.configUI),
          planContract: item.planContract.plan,
          slug: item.slug,
          createdAt: item.createdAt,
          enable: item.enable,
          urlTipo: returnUrl(JSON.parse(item.configUI)),
        })),
      );
    } catch (error) {}
    setIsLoading(false);
  };

  const enableCompany = async (companyId, enable) => {
    const res = await userRequest.put(`/${companyId}/company`, { enable });
    if (res.data > 0) {
      getCompanies();
    } else {
      Swal.fire("Atenção!", "Erro ao inativar usuário!", "error");
    }
  };

  const onButtonDeleteClick = (e, companyId) => {
    if (e.target.checked) {
      enableCompany(companyId, true);
    } else {
      enableCompany(companyId, false);
    }
  };

  const nav = useNavigate();
  const addRow = () => {
    nav(`../onboarding/new`);
  };

  function typeLayout(configUi) {
    if (configUi) {
      switch (configUi.layout) {
        case "category":
          return "1 Categoria";
        case "highligh_category":
          return "Highligh + 1 Categoria";
        case "multi_category":
          return "2 Categorias";
        case "caos":
          return "Caos";
        default:
          return "Atacado";
      }
    }
    return "Atacado";
  }

  function translateLayout(lay) {
    switch (lay) {
      case "1 Categoria":
        return "category";
      case "Highligh + 1 Categoria":
        return "highligh_category";
      case "2 Categorias":
        return "multi_category";
      case "Caos":
        return "caos";
      default:
        return "default";
    }
  }

  const updateLayout = async (row, newLayout) => {
    const rtObj = {
      companyId: row.companyId,
      configUI: {
        imgLogo:
          row.configUI && row.configUI.imgLogo ? row.configUI.imgLogo : null,
        isRetail:
          row.configUI && row.configUI.isRetail ? row.configUI.isRetail : null,
        layout: translateLayout(newLayout),
      },
    };
    const res = await userRequest.put(`${row.companyId}/company/`, {
      configUI: rtObj.configUI,
    });
    if (Object.keys(res.data).length > 0) {
      getCompanies();
    } else {
      Swal.fire("Erro!", "Erro ao atualizar layout!", "error");
    }
  };

  const layoutOptions = [
    "Atacado",
    "1 Categoria",
    "Highligh + 1 Categoria",
    "2 Categorias",
    "Caos",
  ];

  const columns = [
    {
      field: "companyId",
      headerName: "ID da Empresa",
      width: 150,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "name",
      headerName: "Nome",
      width: 200,
      align: "left",
      headerAlign: "left",
      clickable: true,
    },
    {
      field: "layout",
      headerName: "Layout",
      width: 220,
      align: "left",
      headerAlign: "left",
      renderCell: ({ row }) => (
        <select
          defaultValue={row.layout}
          style={{ width: "200px", height: "28px", fontFamily: "Manrope" }}
          onChange={(e) => {
            e.stopPropagation();
            updateLayout(row, e.target.value);
          }}
          onClick={(e) => e.stopPropagation()}
        >
          {layoutOptions.map((opt) => (
            <option key={opt} value={opt}>
              {opt}
            </option>
          ))}
        </select>
      ),
    },
    {
      field: "planContract",
      headerName: "Plano Contratado",
      width: 200,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "slug",
      headerName: "urlEmpresa",
      width: 120,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "urlTipo",
      headerName: "Tipo Url",
      width: 200,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "createdAt",
      headerName: "Criada em",
      width: 200,
      align: "left",
      valueFormatter: (value) => {
        if (value === null) return "";
        return `${formatTimeDDMMYYY(value)}`;
      },
      valueGetter: (value) => value && new Date(value),
    },
    {
      field: "enable",
      headerName: "",
      width: 80,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => (
        <Switch
          defaultChecked={params.row.enable === true}
          onClick={(e) => e.stopPropagation()}
          onChange={(e) => onButtonDeleteClick(e, params.row.companyId)}
        />
      ),
    },
  ];

  return (
    <div className="div_custom_">
      {isLoading ? (
        <Loading />
      ) : (
        <>
          <div className="div_custom_UpdateRight">
            <br></br>
            <Button
              className="custom_add_top"
              variant="outlined"
              color="secondary"
              startIcon={<AddIcon />}
              onClick={addRow}
              size="small"
            >
              Adicionar Empresa
            </Button>
          </div>
          <div className="div_custom_UpdateList">
            <CustomGrid
              gridId="companyList"
              getRowId={(row) => row.companyId}
              rows={data}
              columns={columns}
              onRowClick={(row) => nav(`../onboarding/${row.companyId}`)}
            />
          </div>
        </>
      )}
    </div>
  );
}
